import { Row } from 'components/Containers/Row/Row';
import './CarouselWrapper.scss';

const CarouselWrapper = ({ children, className }) => (
  <Row type="carousel" className={`cus-flexible-carousel ${className}`}>
    {children}
  </Row>
);

export default CarouselWrapper;
